var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.854 2.19C.188 1.28.838 0 1.965 0H14.04c1.124 0 1.774 1.275 1.114 2.185L10.472 8.64v5.982c0 1-1.034 1.667-1.945 1.254l-2.142-.972a1.377 1.377 0 0 1-.808-1.254V8.642L.854 2.19Zm1.413-.66 4.692 6.41c.096.13.148.289.148.451v5.161l1.835.832V8.391c0-.16.051-.318.146-.449L13.74 1.53H2.267Z",
    fill: "currentColor"
  })));
};
export default SvgFilter;